import "./Print.css";

import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import { Link as CustomLink, useSearchParams } from "react-router-dom";

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

import {
  StarRating,
  CheckboxGroup,
  RadioGroup,
  PdfImageWithDownload,
} from "../../../components/PDF/Elements";

const AnswerByEmployee = () => {

  const themeStore = useSelector((state) => state.theme)
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      backgroundColor: themeStore.theme == "dark" ? '#010b25' : "#F0F2F8",
      color: themeStore.theme == "dark" ? "#fff" : "#000"
    },
    section: {
      marginBottom: 10,
      breakInside: "avoid", // Prevents content from splitting across pages
    },
    heading: {
      fontSize: 14,
      fontWeight: "bold",
      marginBottom: 5,
    },
    paragraph: {
      marginBottom: 8,
    },
    title: {
      fontSize: 24,
      marginBottom: 20,
    },
    text: {
      fontSize: 14,
      marginBottom: 10,
      fontWeight: "400",
    },
    fileContainer: {
      marginVertical: 5,
      padding: 5,
      border: "1px solid #eee",
      borderRadius: 4,
    },
    image: {
      maxWidth: 200,
      maxHeight: 150,
      marginBottom: 5,
    },
    que: {
      fontSize: 14,
      marginTop: 30,
      marginBottom: 10,
      fontWeight: "bold",
    },
  });

  const [searchParams] = useSearchParams();
  const staffName = searchParams.get("staffName");

  const [auditQuestions, setAuditQuestions] = useState([]);
  const [questionAnswers, setQuestionAnswers] = useState([]);

  useEffect(() => {
    const auditAnswer = JSON.parse(localStorage.getItem("auditAnswer")) || [];
    if (auditAnswer) {
      setAuditQuestions(auditAnswer.auditQuestions);
      setQuestionAnswers(auditAnswer.questionAnswers);
    }
  }, []);

  const renderField = (field, index) => {
    switch (field.type) {
      case "Text":
        return (
          <View>
            <Text style={styles.text}>{field.value}</Text>

            {field.isFileUpload && field.answer[0].fileName && (
              <PdfImageWithDownload
                fileData={field.answer[0]}
              />
            )}

            {field.rating > 0 && field.answer[0].ratingAnswer > 0 && (
              <View style={{ marginTop: "10px" }}>
                <Text style={styles.text}>Rating</Text>
                <StarRating
                  rating={field.answer[0].ratingAnswer}
                  maxStars={field.rating}
                />
              </View>
            )}
          </View>
        );
      case "Dropdown":
        return (
          <View>
            <View
              style={{
                border: "1px solid #ccc",
                padding: 5,
                borderRadius: 3,
                width: 200,
                marginBottom: 10,
              }}
            >
              <Text>{field.value || "Select an option"}</Text>
            </View>

            {field.isFileUpload && field.answer[0].fileName && (
              <PdfImageWithDownload
                fileData={field.answer[0]}
              />
            )}

            {field.rating > 0 && field.answer[0].ratingAnswer > 0 && (
              <View style={{ marginTop: "10px" }}>
                <Text style={styles.text}>Rating</Text>
                <StarRating
                  rating={field.answer[0].ratingAnswer}
                  maxStars={field.rating}
                />
              </View>
            )}
          </View>
        );
      case "Multi Choice":
        return (
          <View className="mb-2">
            <RadioGroup options={field.options} selectedValue={field.value} />

            {field.isFileUpload && field.answer[0].fileName && (
              <PdfImageWithDownload
                fileData={field.answer[0]}
              />
            )}

            {field.rating > 0 && field.answer[0].ratingAnswer > 0 && (
              <View style={{ marginTop: "10px" }}>
                <Text style={styles.text}>Rating</Text>
                <StarRating
                  rating={field.answer[0].ratingAnswer}
                  maxStars={field.rating}
                />
              </View>
            )}
          </View>
        );
      case "Checkbox":
        return (
          <View className="mb-2">
            <CheckboxGroup options={field.options} selected={field.value} />

            {field.isFileUpload && field.answer[0].fileName && (
              <PdfImageWithDownload
                fileData={field.answer[0]}
              />
            )}

            {field.rating > 0 && field.answer[0].ratingAnswer > 0 && (
              <View style={{ marginTop: "10px" }}>
                <Text style={styles.text}>Rating</Text>
                <StarRating
                  rating={field.answer[0].ratingAnswer}
                  maxStars={field.rating}
                />
              </View>
            )}
          </View>
        );
      case "File Upload":
        return (
          <>
            {field.isFileUpload && field.answer[0].fileName && (
              <PdfImageWithDownload
                fileData={field.answer[0]}
              />
            )}
          </>
        );

      case "Date":
        const formattedDate = field.value
          .split("-")
          .map((part) => part.padStart(2, "0"))
          .join("-");
        return (
          <View className="mb-3">
            <Text style={styles.text}>{formattedDate}</Text>
            <Row className="mt-2">
              {/* {field.isFileUpload && field.answer[0].fileName && (
                <Image src={"https://internaltestinghrms.sktexus.com/assets/audit/2-2025-03-27%2004:58:43.439986Z-857428.jpg"}  style={styles.image}
                    alt="img" />
              )} */}

              {field.isFileUpload && field.answer[0].fileName && (
                <PdfImageWithDownload
                  fileData={field.answer[0]}
                />
              )}

              {field.rating > 0 && field.answer[0].ratingAnswer > 0 && (
                <View style={{ marginTop: "10px" }}>
                  <Text style={styles.text}>Rating</Text>
                  <StarRating
                    rating={field.answer[0].ratingAnswer}
                    maxStars={field.rating}
                  />
                </View>
              )}
            </Row>
          </View>
        );
      case "time":
        return <Text>{field.value}</Text>;
      default:
        return null;
    }
  };

  return (
    <div>
      <div className="page-top-bar" style={{ height: "40px" }}>
        <div
          style={{
            position: "relative",
            top: "10px",
            display: "flex",
            alignItem: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <CustomLink
            onClick={() => localStorage.removeItem("auditAnswer")}
            to={`/audit/report`}
          >
            <ArrowBackIcon sx={{ scale: 1 }} className="color-white" />
          </CustomLink>
          <h1
            style={{
              fontSize: "20px",
              fontWeight: "400",
              position: "relative",
              top: "-3px",
            }}
            className="color-white"
          >
            {staffName}
          </h1>
        </div>
      </div>

      <div
        className="answer-form-pdf"
        style={{ backgroundColor: "transparent", marginTop: "25px" }}
      >
        <PDFViewer width="100%" height={"100%"}>
          <Document>

            {questionAnswers?.map((field, index) => (
              <Page size="A4" style={styles.page} key={index}>
                <View className="header-details">
                  <View style={{ flexDirection: "row", gap: "10px" }}>
                    <Text style={{ fontSize: "16px", fontWeight: "bold" }}>
                      Date:
                    </Text>
                    <Text style={{ fontSize: "16px", fontWeight: "400" }}>
                      {field.date}
                    </Text>
                  </View>
                  <View style={{ flexDirection: "row", gap: "10px" }}>
                    <Text style={{ fontSize: "16px", fontWeight: "bold" }}>
                      Employee Name:
                    </Text>
                    <Text style={{ fontSize: "16px", fontWeight: "400" }}>
                      {staffName}
                    </Text>
                  </View>
                  <View style={{ flexDirection: "row", gap: "10px" }}>
                    <Text style={{ fontSize: "16px", fontWeight: "bold" }}>
                      Branch:{" "}
                    </Text>
                    <Text style={{ fontSize: "16px", fontWeight: "400" }}>
                      {field.branchName}
                    </Text>
                  </View>
                </View>

                <View>
                  <hr
                    style={{
                      border: "1px solid lightgray",
                      marginBottom: "30px",
                    }}
                  />

                  {field.answers == "Not Done" ? (
                    <Text>Not Answered</Text>
                  ) : (
                    field.answers?.map((ans, ansIdx) => {
                      return (
                        <View>
                          <Text style={styles.que}>
                            {ansIdx + 1}. &nbsp; {ans.label}
                          </Text>
                          {renderField(ans, ansIdx)}
                        </View>
                      );
                    })
                  )}
                  {field.overallRating > 0 && (
                    <Text
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        marginTop: "30px",
                      }}
                    >
                      Overall Rating: {field.overallRating}
                    </Text>
                  )}
                </View>
              </Page>
            ))}
          </Document>
        </PDFViewer>
      </div>
    </div>
  );
};

// Create styles


export default AnswerByEmployee;
